/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { getFinanceRefundById } from '@/api/financial-center'
import { menuBtn } from '@/utils/menu_level2_button'

@Component({})
export default class RefundInfo extends Vue {
    logShow = true
    refundId = NaN
    refundInfo = null
    status = ''
    isUpdatedData = '0'
    activities = []
    fileList = []
    financeRefundAccount = null
    financeRefundAccountType = null
    get elImageUrls() {

        if(this.refundInfo.financeRefundProofList && this.refundInfo.financeRefundProofList.length > 0){
            return this.refundInfo.financeRefundProofList.map(item => item.url)
        }
    }

    menuBtn = menuBtn

    created() {
        this.refundId = this.$route.query.refundId as unknown as number
        this.status = this.$route.query.status as string
        this.isUpdatedData = this.$route.query.isUpdatedData as string
        this.getFinanceRefundById()
    }

    formatDate = formatDate

    fileExtension(type) {
        return type.substring(type.lastIndexOf('.') + 1)
    }
    async getFinanceRefundById() {
        const data: any = await getFinanceRefundById({id: this.refundId, isUpdatedData: this.isUpdatedData,})
        this.refundInfo = data.financeRefund

        this.financeRefundAccount  = this.refundInfo.financeRefundAccount
        this.financeRefundAccountType = this.financeRefundAccount ? this.financeRefundAccount.type : null
         //    审批流程
        this.activities = data.financeRefund.messageReviewList
        this.fileList = data.financeRefund.financeRefundProofList
        this.refundInfo.types = this.refundInfo.types == '0' ? '退款退项' : '退款不退项'
    }

    clickEditButton() {
        if(this.status === '审批中') {
            this.$message.error('审批中，不可编辑')
            return
        }
        this.$router.push({
            path: 'newRefund',
            query: {
                refundId: String(this.refundId),
                isUpdatedData: '0'
            }
        })
    }
}
